import { useEffect, useState } from 'react'

import { API_URL } from '@f-fertighaus/applications/Next/api/url'
import { SalesOfficeResponse } from '@f-fertighaus/applications/Next/types/salesOfficeResponse'
import { client } from '@f-fertighaus/applications/Next/utils/client'

type Status = 'idle' | 'loading' | 'resolved'

export const useSalesOfficeData = (
  vendorNid: string,
  postcode: string
): { data: SalesOfficeResponse | null; status: Status } => {
  const [data, setData] = useState<null | SalesOfficeResponse[]>(null)
  const [status, setStatus] = useState<Status>('idle')

  useEffect(() => {
    const fetchData = async () => {
      setStatus('loading')
      const responseData = await client<SalesOfficeResponse[]>(
        API_URL.salesOfficeData(vendorNid, postcode)
      )
      setData(responseData)
      setStatus('resolved')
    }
    fetchData()
  }, [postcode, vendorNid])

  return { data: data ? data[0] : null, status: status }
}
